import {
  Button,
  Modal,
  Form,
  Typography,
  message,
  DatePicker,
  Row,
  Col,
  Spin,
  Input,
  Flex
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useRef,
} from "react";
import { EditOutlined, BankOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

import dayjs from "dayjs";

const uploadLiabilityModalRef = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [initLoading, setInitLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [uploadId, setUploadId] = useState(null);
  const [policyNumber, setPolicyNumber] = useState("");
  const [detailsId ,setDetailsId] = useState(null);
  const uploadRef = useRef(null);
  const { onSuccess } = props;

  const closeModal = () => {
    setVisible(false);
    setUploadId(null);
    setPolicyNumber("");
    setBtnDisabled(false);
    form.resetFields();
  };

  useImperativeHandle(ref, () => ({
    open: async (record = {}) => {
      form.resetFields();
      setUploadId(record?.id || null);
      setPolicyNumber(record?.policyNumber || "");
      setVisible(true);
      setInitLoading(true);
    
  
      try {
        if (record?.id) {
          const res = await http.get(api.getInsuranceById, {
            params: { id: record.id },
          });
          const data = res?.data || {};
           if (data?.buildingList && data.buildingList.length > 0) {
          const firstBuilding = data.buildingList[0];
          form.setFieldsValue({
            liabilityDeductible: firstBuilding.liabilityDeductible || "",
            liabilityLimit: firstBuilding.liabilityLimit || "",
          });
        } else {
          form.setFieldsValue({
            liabilityDeductible: "",
            liabilityLimit: "",
          });
        }
        }
      } catch (err) {
        message.error("Failed to load insurance detail.");
      } finally {
        setInitLoading(false);
      }

    
    },
  }));
  // 提交
  const onFinish = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
       console.log('values',values);
      const params = {
        id: uploadId,
        liabilityDeductible:values.liabilityDeductible,
        liabilityLimit:values.liabilityLimit
      };
      const res = await http.get(api.getUpdateLiabilityRemark, {params});

      if (res?.code === "1") {
        message.success("Upload successfully.");
        closeModal();
        onSuccess && onSuccess();
      } else {
        message.error(res?.msg);
      }
    } catch (err) {
      console.error(err);
      if (!err?.errorFields) {
        message.error("Request failed, please try again");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Row justify="start" align="middle" className="model_title">
          <Col>
            <EditOutlined className="model_title_mr10" />
          </Col>
          <Col>
            <Typography.Title level={4} className="mg">
              UPDATE LIABILITY
            </Typography.Title>
          </Col>
        </Row>
      }
      width="50%"
      style={{
        maxHeight: "70vh",
      }}
      open={visible}
      onCancel={closeModal}
      maskClosable={false}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button onClick={closeModal}>Cancel</Button>
          <Button
            type="primary"
            loading={loading || uploadLoading || initLoading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>
      }
        styles={{
        body: {
          minHeight: "20vh",
          overflowY: "auto",
        },
      }}
    >
      <Spin spinning={initLoading}>
        <Row>
          <div className="model_top" style={{ width: "100%" }}>
            <Form
              form={form}
              name="createBankForm"
              layout="horizontal"
              labelCol={{ flex: "120px" }}
              wrapperCol={{ flex: 1 }}
              style={{ width: "100%" }}
              onFinish={onFinish}
            >
                    <div className="model_content">           
                    {/* <div style={{ marginBottom: 12 }}>
                      Policy Number: {policyNumber || "-"}
                    </div> */}
          <Form.Item 
          label="Policy Number" 
          name="policyNumber" >
          <div style={{ lineHeight: "32px" }}>  
            {policyNumber || "-"}
          </div>
        </Form.Item>     
        <Form.Item
        name="liabilityDeductible"
        label="Deductible" >
         <Input style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          name="liabilityLimit"
         label="Limit">
          <Input style={{ width: "100%" }} />
           </Form.Item>
               
    </div>            
          
            </Form>
          </div>
        </Row>
      </Spin>
    </Modal>
  );
});
export default uploadLiabilityModalRef;
